/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Mock } from 'vitest'

function createAbortControllerMock(abortSpy: Mock) {
  return class AbortControllerMock {
    listeners: Array<(this: AbortSignal, ev: AbortSignalEventMap['abort']) => any> = []
    abort: (reason?: any) => void = abortSpy.mockImplementation((reason) => {
      const signal = this.signal as AbortSignal
      this.signal.aborted = true
      this.signal.reason = reason
      const event = { type: 'abort', cancelable: true } as Event
      signal.onabort?.(event)
      this.listeners.forEach((listener) => listener.bind(this.signal as AbortSignal).call(undefined, event))
    })
    signal = {
      aborted: false,
      onabort: null,
      reason: undefined,
      throwIfAborted: function (): void {
        throw new Error('Aborted')
      },
      addEventListener: <K extends keyof AbortSignalEventMap>(
        _: K,
        listener: (this: AbortSignal, ev: AbortSignalEventMap[K]) => any,
        __?: boolean | AddEventListenerOptions
      ): void => {
        this.listeners.push(listener)
      },
      removeEventListener: <K extends keyof AbortSignalEventMap>(
        _: K,
        listener: (this: AbortSignal, ev: AbortSignalEventMap[K]) => any,
        __?: boolean | EventListenerOptions
      ): void => {
        this.listeners = this.listeners.filter((l) => l !== listener)
      },
    }
  }
}

export default createAbortControllerMock
